import React, { useMemo } from "react";
import { OfficeBuddyData } from "./officebuddy.data";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { SimpleWidget } from "@me8eon/simple_widget";
import { ThemedIcon } from "@me8eon/icons"
import { useCommonComponents } from "@me8eon/components";
import { decodeHTML } from "@me8eon/string_utils";
import { useLanguage } from "@me8eon/language";

export const OfficeBuddyDisplay: DisplayData<OfficeBuddyData> =
    ({ rootId, id, data }: DisplayDataProps<OfficeBuddyData>) => {
        const [lang] = useLanguage();
        const language: 'de' | 'en' = lang === 'de' ? 'de' : 'en';
        const { ClipHeight } = useCommonComponents();
        const { H1WithIconAndUrl, Markdown, Url } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        let cardTitle = data[`title_${language}`] || data.title_en;
        let cardDescription = data[`description_${language}`] || data.description_en;
        cardTitle = decodeHTML(cardTitle);
        cardDescription = cardDescription ? cardDescription.replace(/<[^>]+>/g, ' ').replace(/\n/g, ' ') : cardDescription;
        const url = JSON.parse(data.urls)[0];
        const issueSummaryAndUrl = useMemo(() =>
            ({ url, title: cardTitle, icon: () => <ThemedIcon name="knowledgeBase" /> }), [url, cardTitle]);

        return <DataLayout rootId={newRootId} className='jira-data' layout={[1, 1, 4, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
            {cardDescription !== 'undefined' ? <ClipHeight maxHeight='2rem' force={false}>
                <Markdown rootId={id} attribute={translateLabelForData('data.description')} value={cardDescription} />
            </ClipHeight> : <></>}
            <Url rootId={id} attribute={translateLabelForData('url')} value={url} />
        </DataLayout>;
    };

export const SimpleOfficeBuddyOneLineDisplay: DisplayData<OfficeBuddyData> =
    ({ data, listItemClicked }: DisplayDataProps<OfficeBuddyData>) => {
        const { SearchListItem } = useRenderers();
        const [lang] = useLanguage();
        const language: 'de' | 'en' = lang === 'de' ? 'de' : 'en';
        const title = data[`title_${language}`] || data.title_en;
        const issueSummaryAndUrl = useMemo(() =>
        ({
            title,
            icon: () => <ThemedIcon name="knowledgeBase" />,
            onClick: () => { listItemClicked && listItemClicked(title) }
        }), [title]);


        return (
            <SearchListItem key={title} rootId={title} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
        )
    }
export const SimpleOfficeBuddyWidget: DisplayDataWidget<OfficeBuddyData> =
    SimpleWidget(
        ['name', 'description'],
        ['title_en', 'description_en'],
        ['id']);

